/**
 * CategoryIcon
 *
 * A category's `icon` field may be either an emoji/text (e.g. "🛒") or an image
 * URL set from the admin panel. This renders an <img> when the value looks like
 * a URL, and falls back to rendering the text/emoji in a <span> otherwise.
 *
 * Props:
 *   icon:         the icon value (emoji/text or URL)
 *   fallback:     value used when icon is empty (default '📦')
 *   className:    className for the <span> (text/emoji)
 *   imgClassName: className for the <img> (URL); falls back to className
 *   alt:          alt text for the image
 */
export function isIconUrl(value) {
  if (typeof value !== 'string') return false;
  return /^(https?:)?\/\//i.test(value) || value.startsWith('data:image');
}

function CategoryIcon({
  icon,
  fallback = '📦',
  className = '',
  imgClassName = '',
  alt = '',
}) {
  const value = icon || fallback;

  if (isIconUrl(value)) {
    return (
      <img src={value} alt={alt} className={imgClassName || className || undefined} />
    );
  }

  return <span className={className || undefined}>{value}</span>;
}

export default CategoryIcon;
